import React from 'react'
import PropTypes from 'prop-types'

import { optionListItemStyle, hiddenAnchorStyle } from '../styles'

import RadioInput from '../RadioInput/RadioInput'

const OptionListItemRadio = ({ id, isSelected, onClick, label, children }) => (
  <div className='row' key={id} style={optionListItemStyle}>
    <div className='col-xs-1' >
      <RadioInput selected={isSelected} onClick={() => onClick(id)} />
    </div>
    <div className='col-xs-11' onClick={(e) => { e.preventDefault(); onClick(id);}}>
      <a href='' style={hiddenAnchorStyle}>{label}</a>
    </div>
    {children}
  </div>);

OptionListItemRadio.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired
}

export default OptionListItemRadio